import styled from '@emotion/styled';
import { Pagination as APagination } from 'antd';

export const Pagination = styled(APagination)`
  position: relative;
  padding-left: 210px;
  justify-content: flex-end;

  .ant-pagination-options {
    position: absolute;
    top: 0;
    left: 0;

    &:before {
      content: 'Items per page:';
      padding-right: 10px;
    }
  }
  .ant-pagination-total-text {
    position: absolute;
    top: 0;
    left: 250px;
  }
`;
